import BaseModal from './BaseModal';
import { BaseModalProps, BaseModalTab, BaseModalAction } from './types';

// Exporta o componente principal
export default BaseModal;

// Exporta os tipos para uso externo
export type { BaseModalProps, BaseModalTab, BaseModalAction };
